import { ofType } from "redux-observable";
import { from } from "rxjs";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { actionModalCloseAll, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsDeselect } from "../../player-base/buildings/actionBuildings";
import { TypeActionInventoryInfo } from "./actionInventoryInfo";
import { checkIsResourceGold } from "./checks/checkIsResourceGold";
import { checkIsResourceMoney } from "./checks/checkIsResourceMoney";
import { checkIsResourcePremiumDogTreat } from "./checks/checkIsResourcePremiumDogTreat";
import { pathSelectDogTreatInStoreMenu } from "./paths/pathSelectDogTreatInStoreMenu";
import { pathSelectDollarPackagesInStoreMenu } from "./paths/pathSelectDollarPackagesInStoreMenu";
export var epicInventoryInfoRequestAdd = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionInventoryInfo.RequestAddResource), guard(state$, deps, pathEmpty)([
        checkIsResourceGold(function () {
            return from([
                actionBuildingsDeselect(),
                actionModalCloseAll(),
                actionModalOpen(IdModal.Shop),
            ]);
        }),
        checkIsResourceMoney(pathSelectDollarPackagesInStoreMenu),
        checkIsResourcePremiumDogTreat(pathSelectDogTreatInStoreMenu),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/epicInventoryInfoRequestAdd.ts
// module id = 1904
// module chunks = 3